var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "icon h2"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12m-8 0a8 8 0 1 0 16 0a8 8 0 1 0 -16 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2l0 2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20l0 2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12l2 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12l2 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentIcon);
export default __webpack_public_path__ + "static/media/CurrentIcon.6848a04e67d82d9b12fbacaa11f3947e.svg";
export { ForwardRef as ReactComponent };